import { render, staticRenderFns } from "./ItemBox.vue?vue&type=template&id=074ad2f2&scoped=true&"
import script from "./ItemBox.vue?vue&type=script&lang=js&"
export * from "./ItemBox.vue?vue&type=script&lang=js&"
import style0 from "./ItemBox.vue?vue&type=style&index=0&id=074ad2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ad2f2",
  null
  
)

export default component.exports